import { PartiposterTag, PartiposterTagType } from 'state/partiposter'
import { api, PartipostApiResponse } from './'

export interface GetPartiposterTagListRequestPayload {
    profileUuid: string
    campaign?: string
    target?: string
    type: PartiposterTagType
    campaignOrdering?: string
}

interface SaveTag {
    uuid: string
    text?: string
}

interface BasePartiposterTagRequestPayload {
    profileUuid: string
    submissionUuid?: string
}

export interface SavePartiposterTagRequestPayload extends BasePartiposterTagRequestPayload {
    tags: SaveTag[]
    isProfileTag?: boolean
}

export interface UpdatePartiposterTagRequestPayload extends BasePartiposterTagRequestPayload {
    uuid: string
    text?: string
    tag_uuid: string
}

export interface DeleteTagRequestPayload extends Omit<SavePartiposterTagRequestPayload, 'tags'> {
    uuid: string
    nextPartiposterTag?: PartiposterTag
}

export const getPartiposterTagList = (payload: GetPartiposterTagListRequestPayload) => {
    const { profileUuid, campaign, target, campaignOrdering } = payload
    return api.get<PartipostApiResponse<PartiposterTag[]>>(`partiposter/${profileUuid}/profile-to-tags/`, {
        campaign,
        target,
        campaign_ordering: campaignOrdering,
    })
}

interface SavePartiposterTagRequestBody {
    tag_uuid: string
    submission_uuid?: string | undefined
    text?: string
}

export const savePartiposterTag = (payload: SavePartiposterTagRequestPayload) => {
    const { profileUuid, tags, submissionUuid, isProfileTag } = payload
    const requestBody: SavePartiposterTagRequestBody[] = []
    tags.forEach(t => {
        requestBody.push({
            tag_uuid: t.uuid,
            submission_uuid: !isProfileTag ? submissionUuid : undefined,
            text: t.text,
        })
    })

    return api.post<PartipostApiResponse<PartiposterTag>>(`partiposter/${profileUuid}/profile-to-tags/`, requestBody)
}

export const updatePartiposterTag = (payload: UpdatePartiposterTagRequestPayload) => {
    const { profileUuid, uuid, tag_uuid, text } = payload
    return api.patch<PartipostApiResponse<PartiposterTag>>(`partiposter/${profileUuid}/profile-to-tags/${uuid}/`, {
        tag_uuid,
        text,
    })
}

export const deletePartiposterTag = (payload: DeleteTagRequestPayload) => {
    const { profileUuid, uuid } = payload
    return api.delete<PartipostApiResponse>(`partiposter/${profileUuid}/profile-to-tags/${uuid}/`)
}
